<template>
  <div class="page-product-table-box mt15">
    <div class="tablebox">
      <el-table
        ref="multipleTable" 
        :data="tabledata" 
        tooltip-effect="dark" 
        style="width: 100%"
        size="mini"
      >
        <el-table-column align="left" prop='ShopId' label="ShopID" width="80"></el-table-column>
        <el-table-column :label="$t('dsfx.t57')" prop="ShopName" width="100">
          <template slot-scope="scope">
            <!-- 圆 30天以上
            三角 30天以内
            红为本品投诉记录、黄为被其他品牌投诉过 -->
            <i class="icon-shop-warning icon-shop-warning-c-r" v-if="scope.row.ismore30day/1 === 1 && scope.row.isself/1 === 1"></i>
            <i class="icon-shop-warning icon-shop-warning-t-r" v-if="scope.row.is30day/1 === 1 && scope.row.isself/1 === 1"></i>
            <i class="icon-shop-warning icon-shop-warning-c-y" v-if="scope.row.ismore30day/1 === 1 && scope.row.isnotself/1 === 1"></i>
            <i class="icon-shop-warning icon-shop-warning-t-y" v-if="scope.row.is30day/1 === 1 && scope.row.isnotself/1 === 1"></i> 
            <!-- isYjdf 一件代发/批发 店铺名高亮色 -->
            <a :href="scope.row.ShopUrl" target="_blank" :class="{ispifa : scope.row.isYjdf/1 === 1 ? true :false }">
              {{ scope.row.ShopName }}
            </a>
          </template>
        </el-table-column>
        <el-table-column :label="$t('dsfx.t20')" prop="ChannelName" width="80">
          <template slot-scope="scope">
            <i class="channelicon" :class="scope.row.ChannelName"></i>
          </template>
        </el-table-column>
        <el-table-column prop='shoplevel' :label="$t('Seller.t11')" width="115">
          <template slot-scope="scope">
            <el-rate
              v-model="scope.row.shoplevel"
              disabled
              text-color="#ff9900"
              score-template="{value}">
            </el-rate>            
          </template>
        </el-table-column>
        <el-table-column prop='ShopLab' :label="$t('jgjk.s211')" width="100"></el-table-column>
        <el-table-column prop='Authorize' :label="$t('dsfx.t23')" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.AuthorizeText }}</span>
          </template>
        </el-table-column>
        <el-table-column prop='Discount' :label="$t('report.s51')" width="90"></el-table-column>
        <el-table-column v-if="showecommerce" prop="isQinqText" :label="$t('DashboardProduct.barlegendnamefalse')" width="90"></el-table-column>
        <el-table-column prop='TotalLink' :label="$t('Seller.t12')" width="80"></el-table-column>
        <el-table-column prop='SkuTotalAmountStr' :label="$t('jgjk.s244')" width="90"></el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    tabledata: Array,
    showecommerce: Boolean
  },
}

</script>
